import { useSaveSteps } from "@/hooks/register/use-save-steps";
import { TLocalize } from "@/hooks/use-localize";
import { DashRegistrationStep, historyLinkMap, screeningLinkMap } from "@/types/dashboard";
import { useNavigate } from "react-router";

interface IProps {
    registrationId: number,
    editKey: string,
    isFemale: boolean,
    isLiver: boolean,
    currentRegistrationStep: DashRegistrationStep,
    t: TLocalize,
    isSubmitting: boolean,
    isScreening: boolean
}

const NavigationButtons = ({ registrationId, editKey, isFemale, isLiver, currentRegistrationStep, t, isSubmitting, isScreening }: IProps) => {
    const navigate = useNavigate();
    const { submit, submitError } = useSaveSteps(registrationId, editKey);

    const linkMap = isScreening ? screeningLinkMap(isFemale, isLiver) : historyLinkMap;

    const currentStep = linkMap.find(x => x.step == currentRegistrationStep);

    const handleGoBack = () => {
        if (currentStep != null) {
            if (currentStep.previousStep != null) {
                const previousStep = linkMap.find(x => x.step == currentStep.previousStep);

                if (previousStep != null) {
                    submit(previousStep.step).then((result) => {
                        if (result.ok) {
                            navigate(previousStep.link);
                        }
                    });
                }
            }
        }
    };

    return (
        <div className="form-group register-action col-xs-12">
            {currentStep?.previousStep != null && (
                <>
                    <button
                        type="button"
                        className="btn btn-default btn-med"
                        style={{ marginTop: 20 }}
                        disabled={isSubmitting}
                        onClick={handleGoBack}
                    >
                        <span className="fas fa-arrow-left" aria-hidden="true"></span>&nbsp;
                        {t('Word_Previous', 'Previous')}
                    </button>&nbsp;&nbsp;
                </>
            )}

            <button
                type="submit"
                className={'btn btn-med ' + (isLiver ? 'btn-liver' : 'btn-primary')}
                style={{ marginTop: 20 }}
                disabled={isSubmitting}
            >
                {t('Word_Continue', 'Continue')}
            </button>

            {submitError && <div className="alert alert-danger" style={{ marginTop: 20 }}>{submitError}</div>}
        </div>
    );
}

export default NavigationButtons